import { memo } from 'react';
import { translate } from '../../utils';
import { usePortfolioDashboard } from './PortfolioDashboardContext';
import { PortfolioChangePercentage } from './PortfolioChangePercentage';
import { formatMetricValue, getMetricPreviousComparisonTranslationKey, getMetricNextComparisonTranslationKey } from './portfolioDashboardUtilities';

/** @typedef {import('./portfolioDashboard.types').PortfolioMetric} PortfolioMetric */
/** @typedef {import('./portfolioDashboard.types').PortfolioMetricDefinition} PortfolioMetricDefinition */
/** @param {{ metricDefinition: PortfolioMetricDefinition, metric: PortfolioMetric, currency: string }} props */
export const PortfolioMetricCard = memo(function PortfolioMetricCard({ metricDefinition, metric, currency }) {
    const { period, isTodaySelected } = usePortfolioDashboard();
    const previousChangePercentage = metric[metricDefinition.previousChangePercentageField];
    const nextChangePercentage = metric[metricDefinition.nextChangePercentageField];
    const previousComparisonTranslationKey = getMetricPreviousComparisonTranslationKey(period, isTodaySelected, metricDefinition.usesExtendedComparison);
    const nextComparisonTranslationKey = getMetricNextComparisonTranslationKey(period, isTodaySelected, metricDefinition.usesExtendedComparison);

    return (
        <div className="g-col-12 g-col-md-6 g-col-xl-2">
            <div className="box box-solid h-full mb-0">
                <div className="box-body flex flex-col justify-between h-full">
                    <div className="flex flex-col items-center mb-2">
                        <span className="font-size-h3 text-bold">
                            {formatMetricValue({ value: metric.value, valueFormat: metricDefinition.valueFormat }, currency)}
                        </span>

                        <span className="label label-ghost-primary">
                            {translate('frontend', metricDefinition.labelTranslationKey)}
                        </span>
                    </div>

                    <div className="flex flex-wrap justify-between items-end gap-2">
                        <div>
                            <PortfolioChangePercentage changePercentage={previousChangePercentage} />

                            <p className="font-size-12 text-muted mb-0">
                                {translate('frontend', previousComparisonTranslationKey)}
                            </p>
                        </div>

                        <div className="text-right">
                            <PortfolioChangePercentage changePercentage={nextChangePercentage} />

                            <p className="font-size-12 text-muted mb-0">
                                {translate('frontend', nextComparisonTranslationKey)}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});
